// src/store.js
// Upgraded to use configureStore pattern for better debugging and middleware support
import { createStore, combineReducers, compose } from 'redux';
import titleReducer from './redux/titleSlice';

const rootReducer = combineReducers({
  title: titleReducer,
});

// Enable Redux DevTools if available
const composeEnhancers = 
  (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
  rootReducer,
  composeEnhancers()
);

export default store;
